(function ($, Drupal, cookies, once) {

  'use strict';

    Drupal.behaviors.cookieCategoriesToggle = {
      attach: function (context, settings) {
        once('cookieCategoriesToggle', 'body', context).forEach(function() {
          $('body').on("click", ".category_toggle", function () {
            $(".category_toggle").parent().toggleClass("hidden");
            $("#eu-cookie-compliance-categories").slideToggle();
            $(".eu-cookie-compliance-buttons").toggleClass('hidden');
            $(".eu-cookie-compliance-buttons").slideToggle();
          });

          $('body').on("click", ".toggleInfo", function () {
            $(this).toggleClass('active');
            $(this).parent().parent().toggleClass('active');
            $(this).parent().parent().find('.eu-cookie-compliance-category-description')?.slideToggle();
          });
        });
      }
    }

    Drupal.behaviors.changeCookieAgreedVersion = {
      attach: function (context, settings) {
        $('body').on("click", ".changeCookieSettings", function () {
          cookies.remove("cookie-agreed");
          location.reload();
        })
      }
    }

    $(document).ready(() => {
      if(cookies.get('cookie-agreed') === '2') {
        const categoriesCookie = cookies.get('cookie-agreed-categories');
        if (categoriesCookie) {
          try {
            const categories = JSON.parse(categoriesCookie);
            if(categories && categories.includes("functional")) {
              $("body").addClass('functional-cookies');
            }
          } catch (e) {
            console.warn('Could not parse cookie categories:', e);
          }
        }
      }
    })

  Drupal.behaviors.foldoutPersistence = {
    attach: function (context, settings) {
      once('foldoutPersistence', 'body', context).forEach(function() {
        $('body').on("click", ".paragraph--type--foldout > .block-expandable-header", function (e) {
          let paragraphID = $(this).data("paragraph-id");
          let cookieFoldoutIDs = [];
          if(cookies.get("foldout-ids")) {
            cookieFoldoutIDs  = JSON.parse(cookies.get("foldout-ids"));
          }
          if(cookieFoldoutIDs.includes(paragraphID)) {
            cookieFoldoutIDs = cookieFoldoutIDs.filter(id => id !== paragraphID);
          } else {
            cookieFoldoutIDs.push(paragraphID);
          }
          cookies.set("foldout-ids", JSON.stringify(cookieFoldoutIDs), {expires: (1 / (24*60)) * 5});
        });


        // ON load open all foldouts stored in the cookie
        let cookieFoldoutIDs = [];
        if(cookies.get("foldout-ids")) {
          cookieFoldoutIDs  = JSON.parse(cookies.get("foldout-ids"));
        }
        cookieFoldoutIDs.forEach((id) => {
          $(`.paragraph--type--foldout > .block-expandable-header[data-paragraph-id="${id}"]`).click();
        })
      });
    }
  }

})(jQuery, Drupal, window.Cookies, once);
